// src/sections/ContactUs/ContactUs.tsx
import React from "react";

interface ContactUsProps {
  id: string;
}

const ContactUs: React.FC<ContactUsProps> = ({ id }) => {
  return (
    <section id={id} className="py-0">
      {" "}
      {/* Changed background to a light gray for contrast */}
      <div className="container mx-auto px-4 max-w-7xl text-center">
        {/* Changed text color */}
        <p className="text-xl mb-8 text-gray-600">
          {" "}
          {/* Changed text color */}
          Have a project in mind or need support? Reach out to us!
        </p>
        <form className="max-w-3xl mx-auto space-y-6 p-8 bg-white rounded-lg shadow-md">
          {" "}
          {/* Added padding, background, shadow to form container */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {" "}
            {/* Grid for two columns on medium screens */}
            <input
              type="text"
              placeholder="Your Name"
              className="w-full h-[55px] px-4 text-[15px] rounded-lg bg-white border-l-[3px] border-l-[#7b68ee] shadow-[0_5px_30px_0_rgba(148,146,245,0.15)] placeholder-gray-400 text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
            />
            <input
              type="email"
              placeholder="Your Email"
              className="w-full h-[55px] px-4 text-[15px] rounded-lg bg-white border-l-[3px] border-l-[#7b68ee] shadow-[0_5px_30px_0_rgba(148,146,245,0.15)] placeholder-gray-400 text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
            />
            <input
              type="tel" // Changed to type="tel" for phone numbers
              placeholder="Your Phone"
              className="w-full h-[55px] px-4 text-[15px] rounded-lg bg-white border-l-[3px] border-l-[#7b68ee] shadow-[0_5px_30px_0_rgba(148,146,245,0.15)] placeholder-gray-400 text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
            />
            <input
              type="text"
              placeholder="Your Subject"
              className="w-full h-[55px] px-4 text-[15px] rounded-lg bg-white border-l-[3px] border-l-[#7b68ee] shadow-[0_5px_30px_0_rgba(148,146,245,0.15)] placeholder-gray-400 text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
            />
          </div>
          <textarea
            placeholder="Your Message"
            rows={5}
            className="w-full h-[150px] px-4 text-[15px] rounded-lg bg-white border-l-[3px] border-l-[#7b68ee] shadow-[0_5px_30px_0_rgba(148,146,245,0.15)] placeholder-gray-400 text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300 resize-y"
          ></textarea>
          <button
            type="submit"
            className="bg-purple-600 text-white py-3 px-8 rounded-md text-lg font-semibold hover:bg-purple-700 transition-colors duration-300 shadow-lg"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactUs;
